export default __webpack_public_path__ + "static/media/project-img-5.9ae2118e.png";